import React, { forwardRef, useEffect } from "react";
import PropTypes from "prop-types";
import { MIME_EXTENSIONS } from "~/constants/mime-types";

const videoStyles = { width: "100%", maxWidth: "100%", height: "auto" };

const NativeVideo = ({
  forwardedRef,
  sourcePath,
  mimeType = MIME_EXTENSIONS["mp4"]
}) => {
  useEffect(() => {
    forwardedRef.current.pause();
    forwardedRef.current.load();
  }, [forwardedRef, sourcePath]);

  return (
    <video
      ref={forwardedRef}
      controls
      controlsList="nodownload"
      style={videoStyles}
    >
      <source src={sourcePath} type={mimeType} />
      Dieser Browser untersützt die Wiedergabe von Mp4-Dateien nicht
    </video>
  );
};

NativeVideo.propTypes = {
  forwardedRef: PropTypes.object,
  sourcePath: PropTypes.string,
  mimeType: PropTypes.string
};

const Video = forwardRef((props, ref) => (
  <NativeVideo {...props} forwardedRef={ref} />
));

Video.displayName = "Video";

export default Video;

// class NativeVideo extends Component {
//   shouldComponentUpdate(prevProps) {
//     return prevProps.sourcePath !== this.props.sourcePath;
//   }

//   render() {
//     const {
//       forwardedRef,
//       sourcePath,
//       mimeType = MIME_EXTENSIONS["mp4"]
//     } = this.props;

//     return (
//       <video
//         ref={forwardedRef}
//         controls
//         controlsList="nodownload"
//         style={videoStyles}
//       >
//         <source src={sourcePath} type={mimeType} />
//         Dieser Browser untersützt die Wiedergabe von Mp4-Dateien nicht
//       </video>
//     );
//   }
// }
